<template>
  <div class="trialOrderList">
    <div class="filters">
      <el-form :inline="true">
        <!-- 选择小区下拉框 -->
        <el-form-item>
          <el-select class="select" filterable @change=getStaff(gardenId) v-model="gardenId">
            <!-- <el-option key :label="$t('lang.trialSelectvillageall')" value="0"></el-option> -->
            <el-option v-for="(item,index) in gardenIdlist" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 报事分类 -->
        <el-form-item>
          <el-select class="select" v-model="mainSource">
            <el-option v-for="item in trialType" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 一级报事分类 -->
        <el-form-item>
          <el-select class="select" v-model="firstLevelid" @change="selectSecond(firstLevelid)" multiple filterable
            collapse-tags :placeholder="$t('lang.trialFirstLevelTip')">
            <el-option v-for="(item,index) in firstLevellist" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 二级报事分类 -->
        <el-form-item>
          <el-select class="select" v-model="secondLevelid" @change="selectThird" multiple filterable collapse-tags
            :placeholder="$t('lang.trialSecondLevelTip')">
            <el-option v-for="(item,index) in secondLevellist" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 三级报事分类 -->
        <el-form-item>
          <el-select class="select" v-model="thirdLevelid" multiple filterable collapse-tags
            :placeholder="$t('lang.trialThirdLevelTip')">
            <el-option v-for="(item,index) in thirdLevellist" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <br />
        <!-- 起止时间 -->
        <el-form-item>
          <el-date-picker v-model="datevalues" type="daterange" :range-separator="$t('lang.lab_to')"
            :start-placeholder="$t('lang.lab_startDate')" :end-placeholder="$t('lang.lab_endDate')"
            value-format="timestamp"></el-date-picker>
        </el-form-item>
        <!-- 接单人或报单人 -->
        <el-form-item>
          <el-input class="select" :placeholder="$t('lang.trialMeetPeo')" v-model="sendName"></el-input>
        </el-form-item>
        <!-- 是否包含自动巡检工单 -->
        <el-form-item>
          <el-select class="select" v-model="isQuartzJob">
            <el-option :label="$t('lang.trialIsQuartzJob')" key value=''></el-option>
            <el-option v-for="item in trialIsQuartzJob" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 审阅状态 -->
        <el-form-item>
          <el-select class="select" v-model="isCheck">
            <el-option label="选择审阅状态" key value=''></el-option>
            <el-option v-for="item in reviewType" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 查询按钮 -->
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
        <br />
        <!-- 抽审名称 -->
        <el-form-item>
          <el-input class="select" :placeholder="$t('lang.trialOrderName')" v-model="drawName"></el-input>
        </el-form-item>
        <!-- 负责人下拉框 -->
        <el-form-item>
          <el-select class="select" v-model="chargeLeader" filterable>
            <el-option :label="$t('lang.chargeLeader')" key value=''></el-option>
            <el-option v-for="(item,index) in leaderList" :key="index" :label="item.idNo" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 填写报事类型比例 -->
        <el-button type="primary" @click="jump">{{$t('lang.trialWriteScale')}}</el-button>
        <!-- 生成抽审工单按钮 -->
        <el-button type="primary" @click="createOrder">{{$t('lang.trialCreate')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <!-- 抽审记录按钮 -->
      <el-button slot="header" type="primary" @click="csjl">{{$t('lang.trialNotesBtn')}}</el-button>
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName"
        :height="tableData.length>0 ? require('@/config/enum').tableheight540 : require('@/config/enum').tableheight120">
        <!-- 多选框 -->
        <el-table-column type="selection" width="55" v-if="this.trialOrderListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <!-- id -->
        <el-table-column prop="id" :label="$t('lang.lab_Id')" width="100px"></el-table-column>
        <!-- 报事用户 -->
        <el-table-column :label="$t('lang.lbl_trial_user_nickName')" width="250px">
          <template slot-scope="scope" v-if=" scope.row.user">{{ scope.row.user.nickName }}</template>
          <template slot-scope="scope" v-else>{{ scope.row.userName }}</template>
        </el-table-column>
        <!-- 小区 -->
        <el-table-column :label="$t('lang.lbl_trial_garden_name')" width="150px">
          <template slot-scope="scope">{{ scope.row.garden.name}}</template>
        </el-table-column>
        <!-- 报事方式 -->
        <el-table-column :label="$t('lang.lbl_trial_beginSource')" width="150px">
          <template slot-scope="scope">
            <span :class="{'red':scope.row.isErr===1}"
              v-if="scope.row.beginSource === 1 && scope.row.quartzJobId === 0">{{$t('lang.lbl_trial_beginSource_htbd')}}</span>
            <span :class="{'red':scope.row.isErr===1}"
              v-if="scope.row.beginSource === 1 && scope.row.quartzJobId > 0">{{$t('lang.lbl_trial_beginSource_zdxjgd')}}</span>
            <span :class="{'red':scope.row.isErr===1}"
              v-if="scope.row.beginSource === 2">{{$t('lang.lbl_trial_beginSource_yzbs')}}</span>
            <span :class="{'red':scope.row.isErr===1}"
              v-if="scope.row.beginSource === 3 && scope.row.quartzJobId === 0">{{$t('lang.lbl_trial_beginSource_wybd')}}</span>
          </template>
        </el-table-column>
        <!-- 报事时间 -->
        <el-table-column :label="$t('lang.lbl_trial_createTime')" width="200px" prop="createTime" sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.isOvertime === 1" class="red">{{scope.row.createTime | time}}</span>
            <span v-else>{{scope.row.createTime | time}}</span>
          </template>
        </el-table-column>
        <!-- 楼号 -->
        <el-table-column :label="$t('lang.lbl_trial_garden_grids_houseName')" width="100px">
          <template v-if="scope.row.garden.grids" slot-scope="scope">{{scope.row.garden.grids.houseName}}</template>
        </el-table-column>
        <!-- 单元号 -->
        <el-table-column :label="$t('lang.lbl_trial_garden_grids_unitName')" width="100px">
          <template v-if="scope.row.garden.grids" slot-scope="scope">{{scope.row.garden.grids.unitName}}</template>
        </el-table-column>
        <!-- 房间号 -->
        <el-table-column :label="$t('lang.lbl_trial_garden_grids_roomName')" width="100px">
          <template v-if="scope.row.garden.grids" slot-scope="scope">{{scope.row.garden.grids.roomName}}</template>
        </el-table-column>
        <!-- 报事类型 -->
        <el-table-column :label="$t('lang.lbl_trial_maintainType1_name')" width="100px">
          <template slot-scope="scope">{{ scope.row.maintainType1?scope.row.maintainType1.name : '' }}</template>
        </el-table-column>
        <!-- 工单类型 -->
        <el-table-column :label="$t('lang.lbl_trial_normal')" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.normal === 0">{{$t('lang.lbl_trial_normal_zcgd')}}</span>
            <span v-if="scope.row.normal === 1">{{$t('lang.lbl_trial_normal_ysgd')}}</span>
            <span v-if="scope.row.normal === 2">{{$t('lang.lbl_trial_normal_zbgd')}}</span>
          </template>
        </el-table-column>
        <!-- 工单状态 -->
        <el-table-column :label="$t('lang.lbl_trial_state')" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.state === 1">{{$t('lang.lbl_trial_state_dqr')}}</span>
            <span v-if="scope.row.state === 2" class="red">{{$t('lang.lbl_trial_state_wxz')}}</span>
            <span v-if="scope.row.state === 3">{{$t('lang.lbl_trial_state_ywc')}}</span>
            <span v-if="scope.row.state === 4">{{$t('lang.lbl_trial_state_ypj')}}</span>
            <span v-if="scope.row.state === 5">{{$t('lang.lbl_trial_state_zcgb')}}</span>
            <span v-if="scope.row.state === 6">{{$t('lang.lbl_trial_state_fzcgb')}}</span>
            <span v-if="scope.row.state === 7">{{$t('lang.lbl_trial_state_ycx')}}</span>
          </template>
        </el-table-column>
        <!-- 接单人 -->
        <el-table-column :label="$t('lang.lbl_trial_staffId')" width="260px">
          <template slot-scope="scope">{{scope.row.staffId != 0 ? scope.row.staff.idNo : ""}}</template>
        </el-table-column>
        <!-- 内容 -->
        <el-table-column :label="$t('lang.lbl_trial_content')" prop="content" width="200px">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.content&&scope.row.content.length> require('@/config/enum').tableDatamaxlength12"
              :disabled="false">
              <div slot="content">
                <span>{{ scope.row.content }}</span>
              </div>
              <div class="blue">
                {{ scope.row.content.substring(0, require('@/config/enum').tableDatamaxlength12) | valueIsNull }}
                <span v-if="scope.row.content.length>require('@/config/enum').tableDatamaxlength12">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div class="blue">{{ scope.row.content | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 满意度 -->
        <el-table-column :label="$t('lang.lbl_trial_evaluate')">
          <template slot-scope="scope">
            <span v-if="scope.row.evaluate === 3" class="red">{{$t('lang.lbl_trial_evaluate_bmy')}}</span>
            <span v-if="scope.row.evaluate === 0">{{$t('lang.lbl_trial_evaluate_wpj')}}</span>
            <span v-if="scope.row.evaluate === 1">{{$t('lang.lbl_trial_evaluate_my')}}</span>
            <span v-if="scope.row.evaluate === 2">{{$t('lang.lbl_trial_evaluate_yb')}}</span>
          </template>
        </el-table-column>
        <!-- 详情 -->
        <el-table-column align="center" :label="$t('lang.lab_operation')" prop="operation" fixed="right"
          :width="require('@/config/enum').opr_width1">
          <template slot-scope="scope" align="center">
            <el-button @click="detail(scope.row.id)">{{$t('lang.trialDetailBtn')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <!-- 报事类型比例dialog -->
    <el-dialog :visible.sync="show" :close-on-click-modal="false" center top="130px" width="500px"
      :title="$t('lang.trialReportTitle')">
      <el-scrollbar>
        <el-form label-position="right" label-width="140px">
          <el-form-item label="生成抽审工单数量">
            <el-input-number v-model="randomInspectionCount" controls-position="right" :min="1" :max="999">
            </el-input-number>
          </el-form-item>
          <el-form-item v-for="(item,index) in firstLevelArr" :key="index" :label="item.name" :value="item.id">
            <el-input-number v-model="item.maintainTypeScale" controls-position="right" :min="0" :max="100">
            </el-input-number>
          </el-form-item>
        </el-form>
      </el-scrollbar>
      <div slot="footer">
        <!-- 清空按钮 -->
        <el-button @click="handleDialogClosed()">{{$t('lang.btn_rest')}}</el-button>
        <!-- 保存按钮 -->
        <el-button type="primary" @click="reportKeep()">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
    <!-- 抽审预览dialog -->
    <el-dialog :visible.sync="show1" :close-on-click-modal="false" center top="130px" width="850px"
      :title="$t('lang.trialPreviewTitle')" @close="handleDialogClosed1()">
      <el-scrollbar>
        <el-form class="trees" ref="form" :model="form" :label-width="require('@/config/enum').c_ws4"
          :label-suffix="require('@/config/enum').c_colon">
          <el-table :data="csgd">
            <!-- 小区 -->
            <el-table-column prop="GardenName" :label="$t('lang.lbl_trial_garden_name')" width="150">
            </el-table-column>
			<!-- 工单ID -->
			<el-table-column prop="maintainId" label="工单ID" width="150">
			</el-table-column>
            <!-- 报事用户 -->
            <el-table-column prop="SendName" :label="$t('lang.lbl_trial_user_nickName')">
            </el-table-column>
            <!-- 报事方式 -->
            <el-table-column prop="UserId" :label="$t('lang.lbl_trial_beginSource')" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.UserId === 0">{{$t('lang.lbl_trial_beginSource_yzbs')}}</span>
                <span v-else>{{$t('lang.lbl_trial_beginSource_htbs')}}</span>
              </template>
            </el-table-column>
            <!-- 报事类型 -->
            <el-table-column prop="Normal" :label="$t('lang.lbl_trial_maintainType1_name')" width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.Normal === 0">{{$t('lang.lbl_trial_normal_zcgd')}}</span>
                <span v-else-if="scope.row.Normal === 1">{{$t('lang.lbl_trial_normal_ysgd')}}</span>
                <span v-else>{{$t('lang.lbl_trial_normal_zbgd')}}</span>
              </template>
            </el-table-column>
            <!-- 工单类型 -->
            <el-table-column prop="Type" :label="$t('lang.lbl_trial_normal')" width="80">
            </el-table-column>
            <!-- 删除按钮 -->
            <el-table-column prop="operation" :label="$t('lang.lab_operation')" width="70">
              <template slot-scope="scope">
                <el-button @click="delCsgd(scope.$index,csgd,scope.row.maintainId)">{{$t('lang.btn_delete')}}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </el-scrollbar>
      <div slot="footer">
        <!-- 确定按钮 -->
        <el-button type="primary" @click="previewConfig()">{{$t('lang.btn_confirm')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog title="确认操作" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <span>您所选择园区与左侧园区不一致,确定要执行这个查询吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="getList">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  /**
   *@ClassName:trialOrderList
   *@Description:抽审工单
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-03-23
   */
  import {
    mapGetters
  } from 'vuex'
  export default {
    name: '/manage/main.randomInspectionMaintain',
    data() {
      return {
        dialogVisible: false,
        close: true,
        csgd: [], // 抽审工单预览列表
        csgdId: [], // 抽审工单预览id列表
        pageCount: 0, // 总页数
        pageNum: 1, // 第几页
        pageSize: 10, // 每页显示数
        mainSource: '0', // 报事方式
        isCheck: '', // 审阅状态
        firstLevelid: [], // 一级分类绑定id
        firstLevellist: [], // 一级分类list
        secondLevelid: [], // 二级分类绑定id
        secondLevellist: [], // 二级分类list
        thirdLevelid: [], // 三级分类绑定id
        thirdLevellist: [], // 三级分类list
        typeleval: 1, // 级别接口区分字段
        gardenId: this.$store.getters.gardenId, // 所属小区
        gardenIdlist: [], // 所属小区列表
        datevalues: '', // 开始结束时间绑定值
        sendName: '', // 接单人或报单人input
        isQuartzJob: '', // 是否包含自动巡检工单（0:是,1:否）
        startTs: '', // 开始时间
        endTs: '', // 结束时间
        drawName: '', // 抽审名称
        leaderList: [], // 负责人列表
        chargeLeader: '', // 选择负责人id
        leadername: '', // 选择负责人名称
        show: false, // 报事类型比例弹窗显示状态
        trialOrderListcheckbox: require('@/config/enum').trialOrderListcheckbox, // 是否隐藏复选框
        form: {
          programme: '', // 工程
          customer: '', // 客服
          order: '', // 秩序
          cleaning: '', // 保洁
          green: '', // 绿化
          num1: '0', // 工程比例
          num2: '0', // 客服比例
          num3: '0', // 秩序比例
          num4: '0', // 保洁比例
          num5: '0', // 绿化比例
        }, // 报事类型比例 
        tableData: [], // 抽审工单列表
        show1: false, // 抽审预览弹窗显示状态
        trialType: this.$i18n.t('lang.trialList.trialType'), // 报事方式下拉列表
        trialIsQuartzJob: this.$i18n.t('lang.trialList.trialIsQuartzJob'), // 是否包含自动巡检工单下拉列表
        firstLevelArr: [],
        reviewType: [{
            value: '1',
            label: '合格'
          },
          {
            value: '4',
            label: '优秀'
          }
        ],
        randomInspectionCount: 30, // 生成抽审工单数量（默认30）
      }
    },
    computed: {
      ...mapGetters({
        userDataId: 'staffId',
        userGardenList: 'userGardenList'
      })
    },
    created() {
      // 小区下拉
      this.getGardenId()
      // 一级下拉
      this.maintainTypes()
      // 获取抽审工单列表方法
      this.getList()
      this.getStaff(this.gardenId)
    },
    methods: {
      handleClose() {

      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      // 隔行变色
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNum = val
        this.getList()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        this.getList()
      },
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 报事比例清空方法
      handleDialogClosed() {
        this.firstLevelArr.forEach(item => {
          item.maintainTypeScale = 0
        })
      },
      // 监听关闭抽审预览dialog
      handleDialogClosed1() {
        if (this.close) {
          this.$message({
            type: 'warning',
            message: this.$i18n.t('lang.lab_trialCancelWarning'),
          })
        }
        this.close = true
      },
      // 填写报事比例方法
      jump() {
        this.show = true
      },
      // 报事比例保存方法
      reportKeep() {
        let numAll = 0
        this.firstLevelArr.forEach(item => {
          numAll += item.maintainTypeScale
        })
        if (numAll != 100) {
          this.$message({
            type: 'warning',
            message: this.$i18n.t('lang.lab_trialTotalWarning'),
          })
        } else {
          this.show = false
        }
      },
      // 所属小区下拉列表获取
      getGardenId() {
        // let loading = this.$loading()
        // this.$get(`/gardens`).then(
        //   res => {
        //     // loading.close()
        //     if (res && res.errCode === 0) {
        //       this.gardenIdlist = res.list
        //     }
        //   },
        //   error => {
        //     // loading.close()
        //     this.$message.error(error)
        //   }
        // )
        let myGardens = [...this.userGardenList]
        console.log(myGardens)
        let index = myGardens.findIndex(item => item.id === 0)
        if (index != -1) {
          myGardens.splice(index, 1)
          if (this.gardenId === 0) {
            let newValue = {
              id: 0,
              name: this.$i18n.t('lang.lab_isSelectCommunity')
            }
            myGardens.unshift(newValue)
          } else {
            let newValue = {
              id: 0,
              name: this.$i18n.t('lang.lab_allCommunity')
            }
            myGardens.unshift(newValue)
          }
        }
        this.gardenIdlist = myGardens
      },
      // 获取负责人列表
      getStaff(id) {
        if (id != 0) {
          this.$get(
            `/staffs?gardenId=${id}&pageNo=1&pageSize=999`
          ).then(
            res => {
              if (res && res.errCode === 0) {
                this.leaderList = res.list
                this.chargeLeader = ''
                this.firstLevellist = []
                this.firstLevelid = []
                this.secondLevellist = []
                this.secondLevelid = []
                this.thirdLevellist = []
                this.thirdLevelid = []
                this.typeleval = 1
                this.maintainTypes()
              }
            },
            error => {
              this.$message.error(error)
            }
          )
        } else {
          this.leaderList = []
        }
      },
      // 一级报事分类list
      maintainTypes() {
        // let loading = this.$loading()
        this.$get(
          `/maintainTypes?type=${this.typeleval}&pageNo=${this.pageNum}&pageSize=999&parentId=${this.gardenId}`
        ).then(
          res => {
            // loading.close()
            if (res && res.errCode === 0) {
              if (this.typeleval === 1) {
                this.firstLevellist = res.list
                this.firstLevelArr = res.list.map(item => ({
                  ...item,
                  maintainTypeScale: 0
                }))
                console.log(this.firstLevelArr)
              }
            }
          },
          error => {
            // loading.close()
            this.$message.error(error)
          }
        )
      },
      // 通过一级别查询二级下拉list
      selectSecond(value) {
        if (value == '') {
          this.typeleval = 1
          this.secondLevelid = []
          this.thirdLevelid = []
          this.secondLevellist = []
          this.thirdLevellist = []
        } else {
          this.typeleval = 2
          this.levalmaintainTypes(this.firstLevelid)
          this.secondLevelid = []
          this.thirdLevelid = []
          this.thirdLevellist = []
        }
      },
      // 通过二级别查询三级下拉list
      selectThird(value) {
        this.typeleval = 3
        this.levalmaintainTypes(this.secondLevelid)
        this.thirdLevelid = []
      },
      // 通过级别id查询下一级别list
      levalmaintainTypes(Pid) {
        let loading = this.$loading()
        let params = {
          type: this.typeleval,
          Pid: Pid
        }
        this.$get(
          `/maintainTypeTest`, params).then().then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              if (this.typeleval === 2) {
                this.secondLevellist = res.list
              } else if (this.typeleval === 3) {
                this.thirdLevellist = res.list
              }
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 查询按钮
      commit() {
        this.pageNum = 1
        if (this.$store.getters.gardenId != this.gardenId) {
          this.dialogVisible = true
        } else {
          this.getList()
        }
      },
      // 获取抽审工单列表方法
      getList() {
        this.dialogVisible = false
        if (this.datevalues != null) {
          if (this.datevalues.length > 0) {
            this.startTs = this.datevalues[0]
            this.endTs = this.datevalues[1]
            console.log(this.startTs)
            console.log(this.endTs)
          }
        } else {
          this.startTs = ''
          this.endTs = ''
        }
        let loading = this.$loading()
        let typeUrl =
          `/rimaintains?gardenId=${this.gardenId}&houseId=0&unitId=0&roomId=0&state=0&hasComplain=&pageNo=${this.pageNum}&pageSize=${this.pageSize}&mainSource=${this.mainSource}&staffName=${this.sendName}&isQuartzJob=${this.isQuartzJob}&startTs=${this.startTs}&endTs=${this.endTs}&isCheck=${this.isCheck}`
        if (this.firstLevelid.length > 0) {
          typeUrl += `&maintainTypeId1=${this.firstLevelid}`
        }
        if (this.secondLevelid.length > 0) {
          typeUrl += `&maintainTypeId2=${this.secondLevelid}`
        }
        if (this.thirdLevelid.length > 0) {
          typeUrl += `&maintainTypeId3=${this.thirdLevelid}`
        }

        this.$get(
          typeUrl
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              // 渲染抽审工单列表
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 抽审工单预览方法
      createOrder() {
        if (!this.drawName) {
          this.$message({
            type: 'warning',
            message: this.$i18n.t('lang.lab_trialNameWarning'),
          })
        } else if (!this.chargeLeader) {
          this.$message({
            type: 'warning',
            message: this.$i18n.t('lang.lab_trialPeopleWarning'),
          })
        } else {
          for (let a = 0; a < this.leaderList.length; a++) {
            if (this.chargeLeader == this.leaderList[a].id) {
              this.leadername = this.leaderList[a].idNo
            }
          }
          let numAll = 0
          let arr = []
          this.firstLevelArr.forEach(item => {
            numAll += item.maintainTypeScale
            if (item.maintainTypeScale != 0) {
              arr.push(item.id + '-' + item.maintainTypeScale)
            }
          })
          let maintainTypes = arr.join(',')
          var percentFlag = 0
          // 选比例为1，不选为0
          if (numAll == 100) {
            percentFlag = 1
          } else if (numAll == 0) {
            percentFlag = 0
            maintainTypes = ''
          }
          if (this.datevalues != null) {
            if (this.datevalues.length > 0) {
              this.startTs = this.datevalues[0]
              this.endTs = this.datevalues[1]
              console.log(this.startTs)
              console.log(this.endTs)
            }
          } else {
            this.startTs = ''
            this.endTs = ''
          }
          let url =
            `/createRandomInspectionNew?gardenId=${this.gardenId}&houseId=0&unitId=0&roomId=0&state=0&hasComplain=&pageNo=1&pageSize=10&riName=${this.drawName}&principal=${this.leadername}&staffId=${this.chargeLeader}&percentFlag=${percentFlag}&staffName=${this.sendName}&isQuartzJob=${this.isQuartzJob}&startTs=${this.startTs}&endTs=${this.endTs}&maintainTypes=${maintainTypes}&isCheck=${this.isCheck}&randomInspectionCount=${this.randomInspectionCount}`
          if (this.firstLevelid.length > 0) {
            url += `&maintainTypeId1=${this.firstLevelid}`
          }
          if (this.secondLevelid.length > 0) {
            url += `&maintainTypeId2=${this.secondLevelid}`
          }
          if (this.thirdLevelid.length > 0) {
            url += `&maintainTypeId3=${this.thirdLevelid}`
          }
          let loading = this.$loading()
          this.$get(
            url
          ).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.show1 = true
                this.csgd = res.result
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      },
      // 删除抽审工单预览方法
      delCsgd(index, rows, id) {
        rows.splice(index, 1)
      },
      // 生成抽审工单确认方法
      previewConfig() {
        for (var i = 0; i < this.csgd.length; i++) {
          this.csgdId.push(this.csgd[i].maintainId)
        }
        console.log(this.csgdId.length)
        if (this.csgdId.length != 0) {
          let params = {
            'maintainIdList[]': this.csgdId.toString(),
            riName: this.drawName,
            principal: this.leadername,
            gardenId: this.gardenId,
            staffId: this.chargeLeader,
          }
          this.$post('/commitTrialPreview', params).then(res => {
            if (res.errCode == 0) {
              this.$message({
                type: 'success',
                message: this.$i18n.t('lang.lab_trialSuccess'),
              })
              // 关闭弹窗
              this.show1 = false
              this.csgdId = []
              this.close = false
            } else {
              this.$message({
                type: 'warning',
                message: res.errMsg
              })
            }
          })
        } else {
          // 关闭弹窗
          this.show1 = false
          this.csgdId = []
        }
      },
      // 抽审记录点击
      csjl() {
        this.$router.push({
          name: 'trialNotes'
        })
      },
      // 详情方法
      detail(id) {
        this.$router.push({
          name: 'trialOrderDetail',
          query: {
            id: id
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .trialOrderList .filters {
    background: #fff;
    border-radius: 6px;
    margin-bottom: 20px;
    padding: 20px 20px 20px 20px;
    -webkit-box-shadow: 0 4px 8px 0 #eaeaea;
    box-shadow: 0 4px 8px 0 #eaeaea;
  }

  .trialOrderList .filters .el-range-editor.el-input__inner {
    width: 450px;
  }

  .trialOrderList .filters .select {
    width: 220px;
  }

  .trialOrderList .csjl {
    float: right;
    margin: 20px;
  }

  .trialOrderList .el-dialog .el-form .el-form-item {
    text-align: center;
  }

  .trialOrderList .el-dialog .el-form .el-form-item__label {
    display: inline-block;
    float: none;
  }

  .trialOrderList .el-form-item__content {
    display: inline-block;
  }

  .trialOrderList .trees .el-checkbox {
    width: 20px;
  }

  .trialOrderList .trees {
    height: 500px;
    overflow-y: auto;
  }

  .trialOrderList .trees::-webkit-scrollbar {
    width: 10px;
    height: 1px;
  }

  .trialOrderList .trees::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: rgba(144, 147, 153, 0.3);
  }

  .trialOrderList .trees td {
    padding: 3px 0;
    font-size: 12px;
  }

  .trialOrderList .blue {
    color: #4A88B0
  }
  
  .trialOrderList .el-dialog {
    .el-form {
      // 生成抽审工单数量表单项的特殊样式
      .el-form-item:first-child {
        margin-bottom: 25px;
        padding: 15px;
        background-color: #fdf6ec;
        border: 1px solid #faecd8;
        border-radius: 4px;
      }
    }
  }
</style>